const wstInsuranceMainRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `insurance/wst/index${i + 1}`,
  name: `insuranceWstIndex${i + 1}`,
  component: () => import(`@/views/health/insurance/wst/index${i + 1}.vue`),
}));


export default {
  path: "/health",
  component: { render: (c) => c("router-view") },
  children: [
    // 预约挂号——皖事通，主流程
    ...wstInsuranceMainRoutes,
  ],
};
